import React from "react";
import { SortableHandle } from "react-sortable-hoc";

const DragHandle = SortableHandle(() => <i className="fa fa-grip-vertical file-entry-drag pr-2"/>);
export default DragHandle;
